// import { isIos } from "@/utils/lodash";
// import { baseUrl } from "@/config/config";
// const IOS_ID = "UA-99373601-11";
// const ANDROID_ID = "UA-99373601-12";
// const IOS_GROUP_NAME = "ios";
// const ANDROID_GROUP_NAME = "android";
import { umengNativePoint } from "@/api/http/gx/gxPinAd";
import Http from "@/api/http/fetch/index";
import localStorageHelper from "@/localstorage/localstorage";
import { isIos } from "@/utils/lodash";


// declare let gtag: any;

let PLAT_FORM = "custom";

export const initialAnalytics: any = () => {
  // if (isIos()) {
  //   gtag("config", IOS_ID); //hybrid_alpha_iso
  // } else {
  //   gtag("config", ANDROID_ID); //hybrid_alpha_android
  // }

  if (PLAT_FORM === "custom") {
    //先从local storage 中找：
    if (localStorageHelper.has("plat_form_name")) {
      PLAT_FORM = localStorageHelper.get("plat_form_name");
    } else {
      Http.AppInfo().then((result: any) => {
        PLAT_FORM = result.GETX_PLATFORM;
        localStorageHelper.set("plat_form_name", PLAT_FORM);
      });
    }
  }

  if (
    process.env.NODE_ENV === "development" ||
    process.env.VUE_APP_GOOGLE_ANALYTICS === "OFF"
  ) {
    //测试 和 staging模式下：
    Http.UmengLog("uia_test_hybrid");
  }
};

export const sendEvent = (action: string, label?: string) => {
  // gtag("event", action, {
  //   event_category: PLAT_FORM,
  //   event_label: label
  // });
  console.log("sendEvent:\n", action, ":", label);

  //友盟打点：
  Http.UmengLogWithParam({
    [action]: {
      event_label: label ? label : "null"
    }
  });
  const param = {
    event_id: action,
    event_key: 'event_label',
    event_value: label
  };
  umengNativePoint(param)
};

export const sendObjectEvent = (action: string, label?: any) => {
  // gtag("event", action, {
  //   event_category: PLAT_FORM,
  //   event_label: label
  // });
  console.log("sendEvent:\n", action, ":", label);
  try {
    if (typeof label === "object") {
      label = JSON.stringify(label);
    } else if (typeof label === "string") {
      label = label;
    } else {
      label = label.toString();
    }
  } catch (error) {}

  //友盟打点：
  Http.UmengLogWithParam({
    [action]: {
      event_label: label ? label : "null"
    }
  });
};

export const sendEventWithParams = (action: string, params: {}) => {
  console.log("sendEventWithParams:\n", action, ":", params);
  //友盟打点：
  Http.UmengLogWithParam({
    [action]: params
  });
  const key = Object.keys(params) && Object.keys(params)[0];
  const value = Object.values(params) && Object.values(params)[0];
  if (key) {
    const param = {
      event_id: action,
      event_key: key,
      event_value: value
    };
    umengNativePoint(param);
  }
};

export const sendErrorEventToWindow = (action: string, label?: any) => {
  // gtag("event", action, {
  //   event_category: PLAT_FORM,
  //   event_label: label
  // });
  // console.log("sendEvent:\n", action, ":", label);
  try {
    if (typeof label === "object") {
      label = JSON.stringify(label);
    } else if (typeof label === "string") {
      label = label;
    } else {
      label = label.toString();
    }

    //rollbar打点
    (window as any).onerror("CustomError:" + label, window.location.href);
  } catch (error) {}
};

export const sendError = (description: string, fatal: boolean = false) => {
  // gtag("event", "exception", {
  //   description,
  //   fatal
  // });
};

export const sendEventError = (action: string, obj: any) => {
  // gtag("event", action, {
  //   event_category: PLAT_FORM,
  //   ...obj
  // });

  //友盟打点：
  Http.UmengLogWithParam({
    [action]: obj
  });
};

export const superPayResponse = ({ response, from, pay_way }: any) => {
  //如果是对象:
  try {
    let stringResponse = "";
    if (typeof response === "object") {
      stringResponse = JSON.stringify(response);
    } else {
      stringResponse = response.toString();
    }

    //全部的打点：
    if (response && response.error) {
      if (
        typeof response.error === "string" &&
        response.error.toLowerCase().includes("cancel")
      ) {
        sendEventWithParams("ui_recommend_app_pay_response", {
          [pay_way]: "cancel"
        });
      } else {
        sendEventWithParams("ui_recommend_app_pay_response", {
          [pay_way]: "failed"
        });
      }
    } else if (from === "server") {
      sendEventWithParams("ui_recommend_app_pay_response", {
        [pay_way]: "success"
      });
    }

    //原生和server的打点
    if (from === "native") {
      sendEventWithParams("ui_recommend_app_pay_response_native", {
        [pay_way]: stringResponse
      });
    } else {
      sendEventWithParams("ui_recommend_app_pay_response_server", {
        [pay_way]: stringResponse
      });
    }
  } catch (error) {}
};

export const pageView = (page_path: string) => {
  if (
    process.env.NODE_ENV === "production" &&
    process.env.VUE_APP_GOOGLE_ANALYTICS === "ON"
  ) {
  }
};

const sendInterfaceErrorEvent = (error: any, name: any) => {
  let error_message: any;
  if (error && error.error) {
    error_message = error.error
  } else {
    error_message = error;
  }
  const errCode = (error && error.code) || 400;
  console.log('sendEventError', name, {
    error_code: errCode.toString(),
    error_message
  });
  sendEventError(name, {
    error_code: errCode.toString(),
    error_message
  });
};

const sendInterfaceSuccess = (name: string) => {
  console.log('sendInterfaceSuccess', name, {
    error_code: 200,
    error_message: "ok"
  });
  sendEventError(name, {
    error_code: 200,
    error_message: "ok"
  });
};

export const sendGXError = (error: any, name: any) => {
  sendInterfaceErrorEvent(error, 'ngx_' + name);
};

export const sendIGError = (error: any, name: any) => {
  sendInterfaceErrorEvent(error, 'ig_' + name);
};

export const sendGXSuccess = (name: any) => {
  sendInterfaceSuccess('ngx_' + name);
};

export const sendIGSuccess = (name: any) => {
  sendInterfaceSuccess('ig_' + name);
};
